// src/pages/CharacterSearch.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import apiConfig from '../config/apiConfig';
import './CharacterSearch.css';

const CharacterSearch = () => {
  const [characters, setCharacters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  // Extract query from URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const q = params.get('q');
    if (q) {
      setSearchQuery(q);
      searchCharacters(q);
    }
  }, [location.search]);

  const searchCharacters = async (query) => {
    if (!query.trim()) return;
    
    setLoading(true);
    setError('');
    
    try {
      const response = await fetch(`${apiConfig.getCharacterById}?name=${encodeURIComponent(query)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      });
      
      if (!response.ok) {
        throw new Error('Failed to search for characters');
      }
      
      const data = await response.json();
      setCharacters(Array.isArray(data) ? data : [data]);
    } catch (err) {
      setError(err.message || 'An error occurred while searching');
      console.error('Search error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/character/search?q=${encodeURIComponent(searchQuery)}`);
      searchCharacters(searchQuery);
    }
  };

  return (
    <div className="page-content">
      <h2>Character Search</h2>
      
      <form className="search-form" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Search by character name"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <button type="submit">Search</button>
      </form>
      
      {loading && <div className="loading">Searching...</div>}
      {error && <div className="error-message">{error}</div>}
      
      <div className="search-results">
        {characters.length > 0 ? (
          <>
            <h3>Search Results</h3>
            <div className="character-grid">
              {characters.map((character) => (
                <div key={character.id} className="character-card">
                  <Link to={`/character/view/${character.id}`}>
                    <div className="character-image">
                      {character.icon ? 
                        <img src={`${apiConfig.resources}${character.icon}`} alt={character.username} /> : 
                        <div className="no-image">No Image</div>
                      }
                    </div>
                    <div className="character-info">
                      <h4>{character.username}</h4>
                      <p>Level: {character.level || '1'}</p>
                      <p>Alignment: {character.good > character.evil ? 'Good' : character.evil > character.good ? 'Evil' : 'Neutral'}</p>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </>
        ) : (
          !loading && <p>No characters found. Try a different search term.</p>
        )}
      </div>
    </div>
  );
};

export default CharacterSearch;